/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */
import type { FederatedEmailEntityAti } from '@atlassian/search-client/common/types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from './default-cloud-graph-document-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI } from './default-cloud-graph-message-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from './default-cloud-graph-conversation-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from './default-cloud-graph-design-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from './default-cloud-graph-video-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from './default-cloud-graph-space-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from './default-cloud-graph-comment-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from './default-cloud-graph-work-item-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from './default-cloud-graph-remote-link-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from './default-cloud-graph-calendar-event-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from './default-cloud-graph-devinfo-repository-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI } from './default-cloud-graph-devinfo-pull-request-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from './default-cloud-graph-devinfo-commit-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from './default-cloud-graph-devinfo-branch-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from './default-cloud-graph-project-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from './default-cloud-graph-deal-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from './default-cloud-graph-customer-org-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI } from './default-cloud-graph-dashboard-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI } from './default-cloud-graph-data-table-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI } from './default-cloud-graph-customer-contact-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI } from './default-cloud-graph-campaign-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI } from './default-cloud-graph-case-entity-ati';

// Federated email entities
export const FEDERATED_GOOGLE_EMAIL_ENTITY_ATI = 'ati:third-party:google:email';
export const FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI = 'ati:third-party:microsoft:email';
export const FEDERATED_EMAIL_ENTITY_ATIS: FederatedEmailEntityAti[] = [
	FEDERATED_GOOGLE_EMAIL_ENTITY_ATI,
	FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI,
];
